export const HomePageData = [
    {
        id: 1,
        title: ["K","N","O","W","L","E","D","G","E"],
        icon: "KNOWLEDGE",
        content: `"Your comfort and confidence are my highest priorities.
        For over two decades, I’ve had the privilege of supporting
        a diverse range of clients with their hair needs.
        Through years of dedicated practice, my skills in nurturing,
        styling, and colouring have evolved to an expert level ensuring
        every client feels seen, celebrated, and beautifully cared for."`,
    },{
        id: 2,
        title: "ASSESSMENT",
        icon: ["A","S","S","E","S","S","M","E","N","T"],
        content: `"Once we’ve explored your desired look, I take time to 
        carefully assess the condition of your hair. This ensures that every
        technique I use is tailored not only for stunning results, but also 
        to preserve the health, strength, and integrity of your hair. My 
        approach is both artistic and mindful, designed to bring out your 
        best while keeping your hair beautifully resilient."`,
    },{
        id: 3,
        title: [" "," ","R","E","S","T","O","R","E"],
        icon: "RESTORE",
        content: `"During the restoration phase, only the finest haircare 
        products are chosen, each selected to nourish, strengthen, and
        renew. This is your moment to step away from the demands of 
        daily life and enter a space of transformation. As your hair
        is revived, so too is your sense of self elevated, radiant, 
        and unmistakably you."`,
    },{
        id: 4,
        title: "ALLURE", 
        icon: "ALLURE",
        content: `"As you return to reality, you're met by the magnetic 
        allure of the person in the mirror. The moment you realise that 
        radiant figure is you, your favourite song begins to play, growing 
        louder with every compliment that follows. Your radiance has returned, 
        and with it, your confidence, joy and sense of self.`,
    }
]